import { useCappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite } from '@zg-rentals/ts-capps-client-react-query';

export const GUARANTOR_INVITE_TAG = 'guarantorInvite';

export function useGuarantorInvite(applicationId: string, enabled = true) {
  return useCappsRenterGuarantorInvitationsWebApiHandler_getGuarantorInvite(
    { applicationId },
    {
      enabled,
      meta: {
        tags: [GUARANTOR_INVITE_TAG],
        context: { api: 'cappsRenterGuarantorInvitations', details: 'getGuarantorInvite' },
      },
    },
  );
}
